import React from 'react';
import SvgIcon from './svgIcon';

const SvgPieOver = props => {
  return (
    <SvgIcon width={16} height={14} {...props}>
      <circle r="108" cx="150" cy="150" fill="transparent" strokeWidth="4" stroke="rgb(11, 62, 125)"></circle>
    </SvgIcon>
  );
};

export default SvgPieOver;
